import { createStore, combineReducers, applyMiddleware } from 'redux';
import { localStorageAvailable } from '../common';
import * as reducers from '../reducers';
import * as types from '../constants/ActionTypes';

export default function (initialState) {
  const createStoreWithMiddleware = applyMiddleware(saveLocally)(createStore);
  const reducer = combineReducers(reducers);
  
  if (!localStorageAvailable()) {
    return createStore(reducer, initialState);
  }

  return createStoreWithMiddleware(reducer, initialState);
}

const saveLocally = store => next => action => {
  if (action.type === types.UPDATE_FIELD_VALUE || action.type === types.UPDATE_CUSTOM_FIELD_VALUE && localStorageAvailable) {
    const { name, value } = action.field;
    const field = (action.type === types.UPDATE_FIELD_VALUE) ? name : name + '_custom';
    const productName = store.getState().ConfiguratorStore.getIn(['product', 'name']);
    const productType = store.getState().ConfiguratorStore.getIn(['product', 'type']) + 's';
    const productsString = localStorage.getItem(productType);
    const products = productsString ? JSON.parse(productsString) : {};
    products[productName] = products[productName] ? products[productName] : {};
    products[productName][field] = value;
    localStorage.setItem(productType, JSON.stringify(products));
  }
  return next(action);
}
